import React from 'react';
import { Button, Icon } from 'framework7-react';
import PropTypes from 'prop-types';
import II18 from '../translate/II18';
import { timeStampToDateString } from '../../redux/utils';

export default function StandaloneDraftNotification({
  templateName,
  updatedAt,
  onContinue,
  onClose
}) {
  const savedAt = updatedAt ? timeStampToDateString(updatedAt, true) : '';

  return (
    <div className="notification standalone-draft-notification" slot="fixed">
      <div className="notification-header">
        <div className="notification-title">
          {II18.get('standalone_draft_notification_title')}
        </div>
        <span
          className="notification-close-button"
          role="button"
          tabIndex={0}
          onClick={onClose}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onClose();
            }
          }}
        />
      </div>
      <div className="notification-content">
        <div className="notification-text">
          {II18.get('standalone_draft_notification_text', templateName)}
        </div>
        {savedAt && (
          <div className="standalone-draft-notification-date">{savedAt}</div>
        )}
        <Button
          className="standalone-draft-continue-btn"
          fill
          color="green"
          onClick={onContinue}
        >
          <Icon ios="f7:play_fill" md="material:play_circle_filled" />
          <span>{II18.get('standalone_draft_continue')}</span>
        </Button>
      </div>
    </div>
  );
}

StandaloneDraftNotification.propTypes = {
  templateName: PropTypes.string.isRequired,
  updatedAt: PropTypes.number,
  onContinue: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};
